module.exports = __webpack_public_path__ + "img/P2-A6.071fae48.svg";